// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__G2w7k","title":"ClientReferral_title__1DPEQ","itemText":"ClientReferral_itemText__1NBQl"};